import {
  LOCAL_AUTH_BYPASS,
  LOCAL_WIKI_TOKEN,
  LOCAL_WIKI_USER,
} from './local-auth';

export const WIKI_USER_KEY = 'hero-archive-demo-user';
export const WIKI_AUTH_EVENT = 'game-wiki-auth-change';
export const WIKI_TOKEN_KEY = 'gamekee-access-token';

export type WikiUser = { uid?: number; name: string; method: 'phone' | 'email' | 'nickname'; avatar?: string; phone?: string; email?: string; description?: string };

export function readWikiUser(): WikiUser | null {
  if (LOCAL_AUTH_BYPASS) return { ...LOCAL_WIKI_USER };
  try {
    const value = localStorage.getItem(WIKI_USER_KEY);
    if (!value || !localStorage.getItem(WIKI_TOKEN_KEY)) return null;
    const user = JSON.parse(value) as Partial<WikiUser>;
    return user.name ? {
      uid: user.uid,
      name: user.name,
      method: user.method || 'nickname',
      avatar: user.avatar,
      phone: user.phone,
      email: user.email,
      description: user.description,
    } : null;
  } catch { return null; }
}

export function writeWikiUser(user: WikiUser) {
  localStorage.setItem(WIKI_USER_KEY, JSON.stringify(user));
  localStorage.removeItem('game-wiki-user-v1');
  window.dispatchEvent(new Event(WIKI_AUTH_EVENT));
}

export function readWikiToken() {
  if (LOCAL_AUTH_BYPASS) return LOCAL_WIKI_TOKEN;
  return localStorage.getItem(WIKI_TOKEN_KEY);
}

export function writeWikiSession(user: WikiUser, token: string) {
  localStorage.setItem(WIKI_USER_KEY, JSON.stringify(user));
  localStorage.setItem(WIKI_TOKEN_KEY, token);
  localStorage.removeItem('game-wiki-user-v1');
  window.dispatchEvent(new Event(WIKI_AUTH_EVENT));
}

export function clearWikiUser() {
  localStorage.removeItem(WIKI_USER_KEY);
  localStorage.removeItem('game-wiki-user-v1');
  localStorage.removeItem(WIKI_TOKEN_KEY);
  window.dispatchEvent(new Event(WIKI_AUTH_EVENT));
}
